import React from "react";
import { Alert } from "react-bootstrap";

const FreeSpaceSupplierAlert = () => (
  <Alert bsStyle="danger">
    Die Abrechnung mit dem Lieferanten erfolgt direkt über Deinen Markt. Der
    Lieferant wird angehalten die Rechnung direkt der Bestellung beizulegen.
  </Alert>
);

export default FreeSpaceSupplierAlert;
